<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/KMBF1L/tc-custom/9780674070127.jpg?1705865479042" alt="This image is the cover for the book Nuclear Forces"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Nuclear Forces
      </h1>
      <p class="bookDescription body article font2">
        <b>“A highly readable account . . . tracing the future Nobel laureate through his formative years and up to the eve of World War II” (<i>The Wall Street Journal</i>).</b><br/><br/>On the fiftieth anniversary of Hiroshima, Nobel-winning physicist Hans Bethe called on his fellow scientists to stop working on weapons of mass destruction. What drove Bethe, the head of Theoretical Physics at Los Alamos during the Manhattan Project, to renounce the weaponry he had once worked so tirelessly to create? That is one of the questions answered by <i>Nuclear Forces,</i> a riveting biography of Bethe’s early life and development as both a scientist and a man of principle.<br/><br/>As Silvan Schweber follows Bethe from his childhood in Germany, to laboratories in Italy and England, and on to Cornell University, he shows how these differing environments were reflected in the kind of physics Bethe produced. Many of the young quantum physicists in the 1930s, including Bethe, had Jewish roots, and Schweber considers how Liberal Judaism in Germany helps explain their remarkable contributions. A portrait emerges of a man whose strategy for staying on top of a deeply hierarchical field was to tackle only those problems he knew he could solve.<br/><br/>Bethe’s emotional maturation was shaped by his father and by two women of Jewish background: his overly possessive mother and his wife, who would later serve as an ethical touchstone during the turbulent years he spent designing nuclear bombs. Situating Bethe in the context of the various communities where he worked, Schweber provides a full picture of prewar developments in physics that changed the modern world, and of a scientist shaped by the unprecedented moral dilemmas those developments in turn created.<br/><br/><b>Praise for <i>Nuclear Forces</i></b><br/><br/><b>“Schweber’s account of Hans Bethe’s life . . . reveals the origins of a charismatic scientist, grounded in the importance of his parents and his Jewish roots . . . [Schweber] recreates the social world that shaped the character of the last of the memorable young scientists who established the field of quantum mechanics.” —<i>Publishers Weekly</i></b><br/><br/><b>“<i>Nuclear Forces</i> is a carefully researched, historically and biographically insightful account of the development of a profession and of one of its leading representatives during a century in which physics and physicists played key roles in scientific, cultural, political, and military developments.” —David C. Cassidy, author of <i>A Short History of Physics in the American Century</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Silvan S. Schweber
      </h2>
      
      <p class="authorDescription body article">Silvan S. Schweber is Professor of Physics and Richard Koret Professor in the History of Ideas, Emeritus, at Brandeis University.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harvard University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f9f98d46